import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createMandatoryCourse } from '../../../services/MoodleService';
import { moodleQueryKeys } from '../all-query-keys';

export const useCreateMandatoryCourse = (onSuccess) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: createMandatoryCourse,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: moodleQueryKeys.getConfiguredCourses(),
      });
      onSuccess?.(...args);
    },
  });

  return { mutate, isPending };
};
